import { createContext } from 'react'

export type EndOfArticleContextType = boolean

const EndOfArticleContext = createContext<EndOfArticleContextType>(false)

export default EndOfArticleContext
